module.exports = __webpack_public_path__ + "static/media/13.f9e98384.jpg";